export default [
  // {
  //   path: '404',
  //   component: () => import('./pages/404'),
  //   hidden: true,
  // },
  // {
  //   path: '401',
  //   component: () => import('./pages/401'),
  //   hidden: true,
  // },
  {
    path: '/load-app-error',
    name: 'loadAppError',
    component: () => import('./pages/load-app-error'),
    hidden: true,
  },
  // {
  //   path: '*',
  //   component: () => import('./pages/404'),
  //   hidden: true,
  // },
];
